import * as React from 'react';
import { sendError } from '../sendError';

export class ErrorBoundary extends React.Component {
  componentDidCatch(error: Error) {
    sendError(error);
  }

  render() {
    return this.props.children;
  }
}
